import React from 'react';
import { Shield, Zap, Globe, Gift } from 'lucide-react';

const FeaturesSection: React.FC = () => {
  const features = [
    {
      icon: Shield,
      title: 'Secure & Audited',
      description: 'Smart contracts audited by leading security firms'
    },
    {
      icon: Zap,
      title: 'Lightning Fast',
      description: 'Instant token creation and deployment on Solana'
    },
    {
      icon: Globe,
      title: 'Global Liquidity',
      description: 'Access to deep liquidity pools across DEXs'
    },
    {
      icon: Gift,
      title: 'RevShare Program',
      description: 'Earn 20% commission on referrals'
    }
  ];

  return (
    <section className="py-4 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12">
          Why Choose Aladdin?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-purple-500 transition-colors">
              <feature.icon className="w-10 h-10 text-purple-400 mb-4" />
              <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-400 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;